module.exports = __webpack_public_path__ + "img/img62.5c8066bf.png";